import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(key, { ns: "validation" });
import {
  manipulatedPayloadSchema,
  prescriptionItemSchema,
} from "@/lib/validations/medical-prescription";

const baseTemplateSchema = z.object({
  title: z.string().min(1, t("titleRequired")),
  observations: z.string().optional().or(z.literal("")),
});

const standardTemplateSchema = baseTemplateSchema.extend({
  template_type: z.literal("standard"),
  items: z.array(prescriptionItemSchema).min(1, t("atLeastOneMedication")),
  manipulated_payload: z.any().optional(),
});

const manipulatedTemplateSchema = baseTemplateSchema.extend({
  template_type: z.literal("manipulated"),
  items: z.array(prescriptionItemSchema).optional(),
  manipulated_payload: manipulatedPayloadSchema,
});

export const prescriptionTemplateSchema = z.discriminatedUnion("template_type", [
  standardTemplateSchema,
  manipulatedTemplateSchema,
]);

export type PrescriptionTemplateInput = z.infer<typeof prescriptionTemplateSchema>;
